<template>
    <div class="flex items-center space-x-3">
        <span class="font-medium text-gray-900">{{ data.name }}</span>
        <role-badge v-if="data.role" :role="data.role" />
    </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        required: true
    }
});
</script>